import clsx from "classnames";
import { Container } from "react-bootstrap";
import { Title } from "@/ui";
import HighlightCard from "./components/HighlightCard";
import classes from "./styles.module.scss";

const MAX_CARDS = 4;

/**
 * Row of 1–4 image cards used as campaign / call-to-action banners. Each card has a background
 * image under a coloured overlay, an optional tag, a title, short text and a button, and the
 * whole card is clickable. Cards share the row equally and stack on smaller screens.
 *
 * @param {string} [className] - Additional classes for the root element (spacing).
 * @param {string} [bgColor] - Background colour class for the section.
 * @param {string} [title] - Optional section heading above the cards.
 * @param {string} [titleColor] - Text colour class for the section heading.
 * @param {string} [cardHeight] - "sm", "md" or "lg" minimum card height.
 * @param {Array} [cards] - Card items; only the first four are rendered.
 * @returns {JSX.Element|null}
 */
export const HighlightCards = ({
  className = "py-5",
  bgColor = "bg-white",
  title,
  titleColor = "text-secondary",
  cardHeight = "md",
  cards = [],
}) => {
  const items = (Array.isArray(cards) ? cards : []).slice(0, MAX_CARDS);

  if (!items.length) return null;

  return (
    <div data-component="HighlightCards" className={clsx(className, bgColor, classes.highlightCards)}>
      <Container className="mw-xxl">
        {!!title && <Title title={title} tag="h2" className={clsx("mb-4 text-center", titleColor)} />}

        <div
          data-sourceflow-prop="cards"
          className={clsx(classes.highlightCards__grid, classes[`highlightCards__grid--${cardHeight}`])}
          style={{ "--hc-cols": items.length }}
        >
          {items.map((card, index) => (
            <HighlightCard key={card?.id ?? index} card={card} index={index} wide={items.length === 1} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default HighlightCards;
